import {
  CapaErrorCode,
  CapaQuotationUserRfq,
  CapaRfqStatus,
  FetchQuotationUserRfqsQuery,
  FetchQuotationUserRfqsQueryVariables
} from '@generated/graphql';
import { graphql } from 'msw';

const RFQ_STATUS = [
  CapaRfqStatus.Available,
  CapaRfqStatus.Complete,
  CapaRfqStatus.Confirmed,
  CapaRfqStatus.Confirmed,
  CapaRfqStatus.Expired,
  CapaRfqStatus.ExpiredByClient,
  CapaRfqStatus.ExpiredByRewrite,
  CapaRfqStatus.Stopped
];

const fetchQuotationUserRfqs = graphql.query<
  FetchQuotationUserRfqsQuery,
  FetchQuotationUserRfqsQueryVariables
>('fetchQuotationUserRfqs', (req, res, ctx) => {
  return res(
    ctx.data({
      fetchQuotationUserRfqs: {
        __typename: 'CAPAQuotationUserRfqsOutput',
        result: CapaErrorCode.Success,
        errorMessage: null,
        data: {
          __typename: 'CAPAQuotationUserRfqs',
          count: 11,
          rfqs: RFQ_STATUS.map((status, index, origin) => {
            return {
              createdAt: '2022-12-08T01:41:29.295Z',
              'eventType': 'GENERAL',
              'isItpPartner': null,
              'isTransaction':
                status === CapaRfqStatus.Confirmed &&
                origin[index - 1] === CapaRfqStatus.Confirmed,
              'itpEventRegistered': false,
              'itpEventSent': false,
              'newIntroductionCount': 0,
              'newQuotationCount': 0,
              'projectName': 'PCB A타입 테스트',
              'protoQuantity': null,
              'quantity': 123,
              'receivedQuotationCount': 1,
              'rfqId': '' + index,
              'rfqStatus': status,
              'serviceType': 'CNC',
              'thumbnailId': null,
              'uniqueViews': 4,
              consultingStartMethod: null,
              jsbEventRegistered: null,
              jsbEventSent: null,
              '__typename': 'CAPAQuotationUserRfq'
            } as CapaQuotationUserRfq;
          })
        }
      }
    })
  );
});

export default fetchQuotationUserRfqs;
